import React from 'react'
import Section from './Section'
import BackgroundImage from '../../wp-adons/BackgroundImage'
import { setMargin, setPadding } from '../../utilities'

export default function WorkSection ({
  pageName,
  top_section,
  bottom_section,
  background_image,
  margin_selection,
  padding_selection
}) {
  const pageStyles = {
    ...(setMargin(margin_selection) && { margin: setMargin(margin_selection) }),
    ...(setPadding(padding_selection) && {
      padding: setPadding(padding_selection)
    })
  }
  const loadTop =
    Object.keys(top_section).filter(item => top_section[item] !== '').length > 0
  const loadBottom =
    Object.keys(bottom_section).filter(item => bottom_section[item] !== '')
      .length > 0
  return (
    <div
    style={{ ...pageStyles }}
      className='flex flex-col relative w-full items-center justify-center gap-6 min-h-svh pb-12 sm:pb-0'
      id={pageName}
    >
      {loadTop ? <Section {...top_section} /> : <></>}
      {loadBottom ? <Section {...bottom_section} /> : <></>}
      {background_image && <BackgroundImage background_image={background_image} />}
    </div>
  )
}
